import { useEffect, useState } from 'react'
import { ISpecialRefVotes } from '../../../types'
import { addUrlParams } from '../../../utils'
import { isNativeApp } from '../../../client'
import { SpecialRef } from './SpecialRef'

const getSearchParam = (queryString?: string) => {
  if (!queryString) {
    return null
  }
  const params = new URLSearchParams(queryString)

  if (params.has('q')) {
    return { key: 'q', val: params.get('q') + '' }
  }
  if (params.has('s')) {
    return { key: 's', val: params.get('s') + '' }
  }
  return null
}
export const SpecialRefVotes = ({
  block: { vote, target, direct_link, lp_link, imageObj, grid_title, grid_id },
}: {
  block: ISpecialRefVotes
}) => {
  const [link, setLink] = useState<string | null>(null)

  useEffect(() => {
    const voteParams = getSearchParam(vote)
    if (voteParams) {
      if (isNativeApp()) {
        direct_link && setLink(addUrlParams(direct_link, [{ ...voteParams }]))
      } else {
        lp_link && setLink(addUrlParams(lp_link, [{ ...voteParams }]))
      }
    }
  }, [direct_link, lp_link, vote])

  if (!link) {
    return null
  }
  return (
    <SpecialRef
      specialRef={{
        link,
        imageObj,
        target,
        grid_title,
        grid_id,
        grid_type: 'SpecialRef',
      }}
    />
  )
}
export default SpecialRefVotes
